import { lazy } from 'react';

import { LayoutType, PageType } from '@shared/constants/constants';
import {
  ACTION_BACK_PATH,
  MY_PROFILE_MISMATCH_PATH,
  MY_PROFILE_PATH,
  MY_PROFILE_VERIFICATION_PATH,
} from '@shared/constants/paths';
import { SERVICE_CATALOG_CODE } from '@shared/constants/serviceCatalog';
import type { RouteConfig } from '@shared/types/common.types';

const MyProfilePage = lazy(() => import('@features/HealthProfile/PersonalHealthProfile/pages/MyProfile/MyProfile'));
const VerificationPage = lazy(
  () => import('@features/HealthProfile/PersonalHealthProfile/pages/VerificationPage/VerificationPage')
);
const MismatchPage = lazy(
  () => import('@features/HealthProfile/PersonalHealthProfile/pages/MismatchPage/MismatchPage')
);

export const PERSONAL_HEALTH_ROUTES: RouteConfig[] = [
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.STANDARD],
    component: () => <MyProfilePage />,
    displayTitle: () => 'My Profile',
    pageType: PageType.PRIVATE,
    path: MY_PROFILE_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.myProfile,
    actionUrl: ACTION_BACK_PATH,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.STANDARD],
    component: () => <VerificationPage />,
    displayTitle: () => 'Verification Required',
    pageType: PageType.PRIVATE,
    path: MY_PROFILE_VERIFICATION_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.myProfile,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.STANDARD],
    component: () => <MismatchPage />,
    displayTitle: () => 'Verification Required',
    pageType: PageType.PRIVATE,
    path: MY_PROFILE_MISMATCH_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.myProfile,
  },
];
